import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function ServicesPage() {
  return (
    <main data-testid="services-page">
      <SEO {...SEO_MAP.services} />
      <PageHeader overline="Services" title={<>Seven practices.<br /><em className="italic">One partner.</em></>}
                  lead="Every capability you need to launch, automate and scale — held to the same premium standard." />
      <Services />
      <Process />
    </main>
  );
}
